import { format } from 'owa-localize';
import { makePatchRequest } from 'owa-ows-gateway';

const UNSUBSCRIBE_URL: string = 'ows/api/beta/subscriptions/{0}/unsubscribe';

async function unsubscribeFromBrandSubscriptionService(
    smtpIdentifier: string,
    unsubscribeSilentUris: string[]
): Promise<Response> {
    return await makePatchRequest(
        format(UNSUBSCRIBE_URL, smtpIdentifier) /* requestURL */,
        {
            unsubscribeSilentUris /* requestObject */,
        },
        null /* correlationId */,
        true /* returnFullResponse */
    );
}

export default unsubscribeFromBrandSubscriptionService;
